import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getProductsFromExternalApi,
  updateProduct as updateProductService,
  getProduct as getProductService,
} from "../../services/ProductService";
import {
  ProductState,
  Product,
  ProductDetail,
} from "../../interfaces/product-interface";

export const listProducts = createAsyncThunk(
  "products/listProducts",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const products = await getProductsFromExternalApi(token);
      return products.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async ({ name, data }: { name: string; data: ProductDetail }, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const updatedProduct = await updateProductService(token, name, data);
      return updatedProduct;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Failed to update product");
    }
  }
);

export const getProduct = createAsyncThunk(
  "products/getProduct",
  async (name: string, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const products = await getProductService(name);
      return products.data;
    } catch (error) {
      console.log(error, "EROOORRRRR");
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: {
    products: [] as Product[],
    selectedProduct: null as Product | null,
    status: "idle",
    error: null,
  } as ProductState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.products = action.payload;
        state.error = null;
      })
      .addCase(listProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(getProduct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedProduct = action.payload;
        state.error = null;
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default productsSlice.reducer;
